import type { IAccessPinRepository, PinGenerateResponse, PinStatusResponse } from '@yawi/domain';
import { getApiClient } from '../../http/apiClient';

export class ApiAccessPinRepository implements IAccessPinRepository {
  async getMyPin(): Promise<PinStatusResponse> {
    const client = getApiClient();
    return await client.get<PinStatusResponse>('v1/access/pin/my');
  }

  async generatePin(): Promise<PinGenerateResponse> {
    const client = getApiClient();
    return await client.post<PinGenerateResponse>('v1/access/pin/generate');
  }

  async regeneratePin(): Promise<PinGenerateResponse> {
    const client = getApiClient();
    return await client.post<PinGenerateResponse>('v1/access/pin/regenerate');
  }

  async deletePin(): Promise<void> {
    const client = getApiClient();
    await client.delete('v1/access/pin');
  }
}
